<template>
  <div class="yuyuejisao">
    <div class="serviceTitle">预约祭扫信息</div>
    <div class="content">
      <van-form ref="form">
        <van-cell title="祭扫日期" :value="formData.predate" @click="show = true" />
        <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        <van-calendar v-model="show" @confirm="onConfirm" />
        <van-cell-group>
          <van-field
            v-model="formData.mobile"
            label="预约人手机号"
            type="tel"
            placeholder="请输入预约人手机号"
            required
            :rules="telRules"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="formData.userCount"
            label="同行人数"
            type="digit"
            placeholder="请输入同行人数"
            required
            :rules="tongxingRules"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="formData.userName"
            label="预约人姓名"
            placeholder="请输入预约人姓名"
            required
            type="text"
            :rules="xingmingRules"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="formData.idCard"
            type="text"
            label="预约人身份证"
            placeholder="请输入预约人身份证"
            required
            :rules="shenfenzhengRules"
          />
        </van-cell-group>
        <div class="bottom">
          <van-button
            v-if="saveFlag"
            round
            block
            type="info"
            native-type="submit"
            @click="submitForward(1)"
            >提交预约</van-button
          >
          <van-button
            v-else
            round
            block
            type="info"
            style="background:#ccc;"
            @click="submitForward(2)"
            >提交预约</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yuyuejisao',
  data() {
    return {
      formData: {
        predate: '',
        mobile: '',
        userCount: '',
        userName: '',
        idCard: '',
        myId: this.$store.getters.userId,
      },
      saveFlag: false,
      show: false,

      // 校验手机号码
      telRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
        {
          // 自定义校验规则
          validator: value => {
            return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
              value
            )
          },

          trigger: 'onBlur',
        },
      ],

      tongxingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],

      xingmingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],

      shenfenzhengRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],
    }
  },
  computed: {},
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf('jisao') > -1) {
      localStorage.setItem('reload', 'true')
    } else {
      localStorage.removeItem('reload')
    }
    next()
  },
  created() {
    if (localStorage.getItem('reload')) {
      location.reload()
    }
  },
  mounted() {},
  methods: {
    submitForward() {
      let that = this
      this.$submit('/api/msgforward/addForward', this.formData, function(res) {
        if (res['code'] === 1) {
          that.$toast.success('提交成功！')
        }
      })
    },
    formatDate(predate) {
      console.log(predate)
      return `${predate.getFullYear()}-${predate.getMonth() + 1}-${predate.getDate()}`
    },
    onConfirm(predate) {
      this.show = false
      this.formData.predate = this.formatDate(predate)
    },
  },
  watch: {
    formData: {
      handler() {
        if (
          /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
            this.formData.mobile
          ) &&
          this.formData.userName &&
          this.formData.idCard &&
          this.formData.userCount &&
          this.formData.predate
        ) {
          this.saveFlag = true
        } else {
          this.saveFlag = false
        }
      },
      deep: true,
    },
  },
}
</script>

<style>
.yuyuejisao .content {
  position: relative;
}
.van-field__control {
  text-align: right;
}
.van-cell__value span {
  padding-right: 1.5rem;
}
.yuyuejisao .bottom {
  margin: 4rem auto;
  width: 80%;
  height: 4rem;
  line-height: 4rem;
  font-size: 1.6rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}

.yuyuejisao .bottom van-button {
  position: relative;
  width: 100%;

  font-size: 1.4rem;
  text-align: center;
  background-color: #15a892;
  color: #fff;
  border-radius: 2500px;
}
.yuyuejisao .van-cell {
  height: 5rem;
  line-height: 5rem;
}
.yuyuejisao .van-cell-group {
  height: 5rem;
  line-height: 5rem;
}

.yuyuejisao .serviceTitle {
  padding: 1.3rem 0;
  line-height: 4rem;
  height: 4rem;
  font-size: 1.8rem;
  width: 100%;
  padding: 10px 16px;
  margin: 0 auto;
}
.yuyuejisao .jiantou {
  position: absolute;
  right: 1rem;
  top: 2.2rem;
}
</style>
